// Custom JS added by Paramount Digital

window.reinitializeTrustpilotWidgets = function reinitializeTrustpilotWidgets(root = document) {
  const scope = root || document;
  const widgets = [];

  if (scope.matches?.('.trustpilot-widget')) widgets.push(scope);
  scope.querySelectorAll?.('.trustpilot-widget').forEach((widget) => widgets.push(widget));

  if (!widgets.length) return;

  const loadWidgets = () => {
    if (!window.Trustpilot?.loadFromElement) return;
    widgets.forEach((widget) => window.Trustpilot.loadFromElement(widget, true));
  };

  if (window.Trustpilot?.loadFromElement) {
    loadWidgets();
    return;
  }

  const startedAt = Date.now();
  const timer = setInterval(() => {
    if (window.Trustpilot?.loadFromElement) {
      clearInterval(timer);
      loadWidgets();
    } else if (Date.now() - startedAt > 5000) {
      clearInterval(timer);
    }
  }, 100);
};

class CollectionBannerFilters extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.syncFromDrawer = this.syncFromDrawer.bind(this);
    this.hideMatchingActiveFacets = this.hideMatchingActiveFacets.bind(this);

    this.addEventListener('click', this.onClick);
    document.addEventListener('collection:rerendered', this.syncFromDrawer);
    document.addEventListener('collection:rerendered', this.hideMatchingActiveFacets);
    this.syncFromDrawer();
    this.hideMatchingActiveFacets();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    document.removeEventListener('collection:rerendered', this.syncFromDrawer);
    document.removeEventListener('collection:rerendered', this.hideMatchingActiveFacets);
  }

  getDrawerInput(paramName, value) {
    const inputs = document.querySelectorAll(`#DrawerFacetFiltersContainer input[name="${paramName}"]`);
    return Array.from(inputs).find((input) => input.value === value);
  }

  getBannerFilterParams() {
    return Array.from(document.querySelectorAll('collection-banner-filters[data-filter-param]'))
      .map((el) => el.dataset.filterParam)
      .filter(Boolean);
  }

  hideMatchingActiveFacets() {
    const params = this.getBannerFilterParams();
    const activeFacets = document.getElementById('FacetFiltersActive');
    if (!activeFacets) return;

    activeFacets.querySelectorAll('.facet-remove[data-filter-param]').forEach((chip) => {
      const shouldHide = params.includes(chip.dataset.filterParam);
      chip.hidden = shouldHide;
      chip.classList.toggle('hidden', shouldHide);
    });
  }

  onClick(event) {
    const trigger = event.target.closest('[data-filter-param][data-filter-value]');
    if (!trigger || !this.contains(trigger) || trigger.disabled) return;

    event.preventDefault();

    const input = this.getDrawerInput(trigger.dataset.filterParam, trigger.dataset.filterValue);
    if (!input || input.disabled) return;

    input.click();
  }

  syncFromDrawer() {
    this.querySelectorAll('[data-filter-param][data-filter-value]').forEach((trigger) => {
      const input = this.getDrawerInput(trigger.dataset.filterParam, trigger.dataset.filterValue);
      if (!input) return;

      trigger.disabled = input.disabled;
      trigger.setAttribute('aria-pressed', String(input.checked));

      if (trigger.classList.contains('collection-hero-links__card')) {
        trigger.classList.toggle('is-active', input.checked);
      } else {
        trigger.classList.toggle('btn--active', input.checked);
      }
    });
  }
}

if (!customElements.get('collection-banner-filters')) {
  customElements.define('collection-banner-filters', CollectionBannerFilters);
}